






























import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Mixins
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

@Component({
  computed: {
    ...mapGetters({
      canShowNotesAndSecrets: "data/clients/vaultAssets/canShowNotesAndSecrets"
    })
  },
  components: {
    "vault-provider": () =>
      import("@/components/app/global/vault/vaultProvider.vue"),
    "vault-secret-form": () =>
      import("@/components/app/global/vault/vaultSecretForm.vue"),
    "vault-secrets-listing": () =>
      import("@/components/app/global/vault/vaultSecretsListing.vue")
  }
})
export default class CProdSecretsComp extends Mixins(CProdInjectorMixin) {
  // Getters

  public canShowNotesAndSecrets!: boolean;

  // Props
  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Computed

  public get vaultProviderProps() {
    return {
      accountId: this.cProdData.contract?.account_id,
      clientId: this.cProdData.contract?.client_id,
      contractProductId: this.cProdData.contractProduct?.id,
      dataScope: `$cprod_${this.cProdData.contractProductId}_secrets`,
      limit: 3,
      manualFilters: {
        "filter[encrypted]": true
      }
    };
  }

  public get secretsListingProps() {
    return {
      skeletonCount: 0,
      showEmptyState: false,
      isDisabled: this.isDisabled,
      ...this.$_.pick(this.vaultProviderProps, [
        "accountId",
        "clientId",
        "contractProductId"
      ])
    };
  }
}
